import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import LanguageSelector from '../components/LanguageSelector';

// Set once the user has picked a language on first launch, so the dedicated
// language step is skipped on every subsequent visit.
export const LANGUAGE_CHOSEN_KEY = 'language_chosen';

export function languageChosen(): boolean {
  try { return localStorage.getItem(LANGUAGE_CHOSEN_KEY) === '1'; } catch { return false; }
}

// Shown before any language is chosen, so the copy is intentionally bilingual
// (English + Spanish) and NOT routed through i18n. Tapping a language applies
// it live and advances straight into the (now localized) onboarding.
export default function Language() {
  const navigate = useNavigate();
  const { colors } = useTheme();

  const handleChosen = () => {
    try { localStorage.setItem(LANGUAGE_CHOSEN_KEY, '1'); } catch { /* ignore */ }
    navigate('/onboarding', { replace: true });
  };

  return (
    <div
      style={{
        minHeight: '100dvh',
        backgroundColor: colors.bg,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '0 28px',
        paddingTop: 'env(safe-area-inset-top, 0px)',
      }}
    >
      <div
        style={{
          width: 80, height: 80, borderRadius: 22, backgroundColor: '#000',
          display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
          alignSelf: 'center', marginBottom: 28,
        }}
      >
        <img src="/icons/icon-512.png" alt="" style={{ width: 62, height: 62, objectFit: 'contain' }} />
      </div>

      <div style={{ fontSize: 28, fontWeight: 900, color: colors.text, textAlign: 'center' }}>Welcome to AGA</div>
      <div style={{ fontSize: 18, fontWeight: 700, color: colors.textSub, textAlign: 'center', marginTop: 4 }}>Bienvenido a AGA</div>

      <div style={{ marginTop: 36, marginBottom: 18 }}>
        <div style={{ fontSize: 16, fontWeight: 800, color: colors.text, textAlign: 'center' }}>Choose your language</div>
        <div style={{ fontSize: 14, fontWeight: 600, color: colors.textSub, textAlign: 'center', marginTop: 2 }}>Elige tu idioma</div>
      </div>

      <LanguageSelector onChanged={handleChosen} />
    </div>
  );
}
